import { useState } from "react";
import { supabase } from "./SupabaseClient";
import { useNavigate, Link } from "react-router-dom";
const Register = () => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    setEmail("");
    setUsername("");
    setPassword("");
  };
  const handleRegister = async (e) => {
    e.preventDefault();

    // STEP 1: Create the User in the "Auth" room
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email: email,
      password: password,
    });

    if (authError) {
      alert("Auth Error: " + authError.message);
      return;
    }

    // STEP 2: Create the row in your "profiles" table
    if (authData.user) {
      const { error: profileError } = await supabase.from("profiles").insert([
        {
          id: authData.user.id, // This links the profile to the auth account
          username: username,
          email: email,
        },
      ]);

      if (profileError) {
        alert("Database Error: " + profileError.message);
      } else {
        alert("Account created successfully");
        {
          navigate("/Login");
        }
      }
    }
  };

  return (
    <>
      <h1>Register</h1>
      <form name="register" onSubmit={handleSubmit}>
        <label
          htmlFor="email"
          className="email"
          placeholder="johndoe@example.com"
        >
          Email
        </label>
        <input
          autoComplete="off"
          type="email"
          value={email}
          id="email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <label htmlFor="username" className="username" placeholder="johndoe">
          Username
        </label>
        <input
          autoComplete="off"
          type="text"
          value={username}
          id="username"
          onChange={(e) => setUsername(e.target.value)}
        />
        <label htmlFor="password" className="password" placeholder="123$">
          Password
        </label>
        <input
          autoComplete="off"
          type="password"
          value={password}
          id="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" onClick={handleRegister}>
          Register
        </button>
        <Link to="/Login">Back to Login</Link>
      </form>
    </>
  );
};
export default Register;
